import React from 'react';

// Assets
import './Information.css';
import brokercheck from '../../images/brokercheck_finra.png'


export default function Information() {
  return (
    <div className='floatingInformation'>
      <div className='information'>
        <div className='information-image'>
          <a href='https://brokercheck.finra.org/' target='_blank' rel='noreferrer'>
            <img src={brokercheck} alt='broker check logo' />
          </a>
        </div>

        <div className='information-btns'>
          <a className='btnSecurities ' href='https://assets.osaic.com/m/f971a637fff07a0/original/Form-CRS.pdf' target='_blank' rel='noreferrer'>
            Osaic Wealth Form <br/> CRS
          </a>
        </div>
      </div>
    </div>
  );
}